import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import show from './show.vue'
import 'lib-flexible'
import axios from 'axios'
import VueRouter from 'vue-router'
import dasai from '../../components/dasai.vue'
import chengguo from '../../components/chengguo.vue'
import fuping from '../../components/fuping.vue'
import qidong from '../../components/qidong.vue'

Vue.prototype.$axios = axios
Vue.use(ElementUI);
Vue.use(VueRouter)

const routes = [{
  name: 'dasai',
  path:'/dasai',
  component:dasai
},{
  name: 'chengguo',
  path:'/chengguo',
  component:chengguo
},{
  name: 'fuping',
  path:'/fuping',
  component:fuping,
},{
  name: 'qidong',
  path:'/qidong',
  component:qidong
}]
const router = new VueRouter({
  routes
})
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

Vue.config.productionTip = false

new Vue({
	router,
  render: h => h(show),
}).$mount('#app')
